// import React from 'react'
import PouchDB from 'pouchdb';
import MessageService from './MessageService';

const db = new PouchDB('http://genesis-test-web01-neu:5984/lookupFullElements');
const messageService = new MessageService();
// const statistics = ""

// class for PouchDB data handling
export default class UpdateService {
  // STUB
  updatePouch = () => {
    try {
      messageService.postDataStockProperties([{ name: '21311' }], 'structureElementsListFromStatistic', 'structure')
        .then((result) => {
          // console.log("LE RESULT", result);
          try {
            const elements = result.data.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys;
            // write Merkmale as full elements to pouchdb
            // console.log("this.db", db)
            for (let i = 0; i < elements.length; i += 1) {
              const fullElement = elements[i];
              // eslint-disable-next-line no-underscore-dangle
              fullElement._id = fullElement.name;

              db.put(fullElement).then(() => {
                // eslint-disable-next-line no-console
                console.log('Updated stuff');
                // success
              }).catch((err) => {
                if (err.name === 'conflict') {
                  // conflict!
                  // console.log("LEL");
                } else {
                  // eslint-disable-next-line no-console
                  console.log('Updater Non-Conflict-Error', fullElement.name, err);
                }
              });
            }
          } catch (err) {
            // eslint-disable-next-line no-console
            console.log('ERROR in UpdateService', err);
          }
        });
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log('ERROR in UpdateService: postDataStockProperties', err);
    }
  }

  // method for DB subscribtion, requires a callback function
  // which defines update behaviour when DB content changes
  updater(isActive) {
    // deactivated due to high traffic
    if (isActive) {
      setInterval(this.updatePouch, 360000);
    }
  }
}
